import React, { useState, useEffect } from "react";
import { MdOutlineLocationSearching } from "react-icons/md";
import useClickOutside from "../../../customHooks/useClickOutside";
import FilterActionButton from "../../FilterActionButton";
import classes from "./MedicineEstimatedValue.module.css";
import { Row, Col } from "react-bootstrap";
import { Dropdown } from "../../Dropdown";
import { Input } from "../../Input";
import { BsGraphUpArrow } from "react-icons/bs";
const options = [
  { label: "All Value", value: { minTarget: 0, maxTarget: 0 } },
  { label: "Rs.0 to 10,000", value: { minTarget: 0, maxTarget: 10000 } },
  { label: "Rs 10,000 to 30,000", value: { minTarget: 10000, maxTarget: 30000 } },
  { label: "Rs 30,000 to 60,000", value: { minTarget: 30000, maxTarget: 60000 } },
  { label: "Rs 60,000 above", value: { minTarget: 30000, maxTarget: 0 } },
  { label: "Custom Target", value: "custom" },
];
const PopperMedicineTarget = ({
  lists = null,
  setter = () => { },
  children,
  listsClass = "",
  listStyle = null,
  minTarget,
  setMinTarget,
  maxTarget,
  setMaxTarget,
}) => {

  const [isListOpen, setIsListOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [debounceMinTarget, setDebounceMinTarget] = useState(0);
  const [debounceMaxTarget, setDebounceMaxTarget] = useState(0);

  const [ref] = useClickOutside(() => {
    // setIsListOpen(false);
  });


  const setTargetsHandler = (val) => {
    setSelectedOption(val);
    if (val == "custom") {
      setDebounceMaxTarget(0);
      setDebounceMinTarget(0);
    }
    else {
      setDebounceMaxTarget(val?.value?.maxTarget);
      setDebounceMinTarget(val?.value?.minTarget);
    }
  }

  useEffect(() => {
    const effect = setTimeout(() => {
      setMaxTarget(debounceMaxTarget);
      setMinTarget(debounceMinTarget);
    }, 300);
    return () => clearTimeout(effect);
  }, [debounceMaxTarget, debounceMinTarget]);


  return (
    <div className={classes.wrapper} ref={ref}>
      <span>
        <FilterActionButton
          className={classes.iconHolder}
          onClick={() => {
            setIsListOpen((currentState) => !currentState);
          }}
        >
          <BsGraphUpArrow />
          {/* <MdOutlineLocationSearching /> */}
        </FilterActionButton>
      </span>

      <div
        style={{ ...listStyle }}
        className={[
          classes.actionsListWrapper,
          !isListOpen && classes.listClose,
          listsClass,
        ].join(" ")}
      >
        <Row>
          <Col sm={4}>
            <Dropdown options={options} placeholder={"All Target"} value={selectedOption} setter={(val) => setTargetsHandler(val)} />
          </Col>
          <Col sm={4}>
            <Input
              type="number"
              placeholder="Min Target"
              setter={setDebounceMinTarget}
              value={debounceMinTarget}
              parentCustomStyle={{ height: "100%" }}
              customStyle={{ height: "100%" }}
              disabled={selectedOption?.value !== "custom"}
            />
          </Col>
          <Col sm={4}>
            <Input
              type="number"
              placeholder="Max Target"
              setter={setDebounceMaxTarget}
              value={debounceMaxTarget}
              parentCustomStyle={{ height: "100%" }}
              customStyle={{ height: "100%" }}
              disabled={selectedOption?.value !== "custom"}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PopperMedicineTarget;
